import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer id='footer' className='footer'>
      <div className='footer-top'>
        <div className='container'>
          <div className='row gy-4'>
            <div className='col-lg-5 col-md-12 footer-info'>
              <a href='index.html' className='logo d-flex align-items-center'>
                <img src='assets/img/logo.png' alt='' />
              </a>
              <p>
                REAN aspires to contribute significantly in improving India's
                infrastructure by its proficiency in water treatment and
                distribution along with waste management in municipal,
                commercial and industrial territories.
              </p>
              <div className='social-links mt-3'>
                <a href='#' className='twitter'>
                  <i className='bi bi-twitter'></i>
                </a>
                <a href='#' className='linkedin'>
                  <i className='bi bi-linkedin bx bxl-linkedin'></i>
                </a>
              </div>
            </div>

            <div className='col-lg-2 col-6 footer-links'>
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <i className='bi bi-chevron-right'></i>
                  <Link to='/'>Home</Link>
                </li>
                <li>
                  <i className='bi bi-chevron-right'></i>
                  <Link to='/about-us'>About Rean</Link>
                </li>
                <li>
                  <i className='bi bi-chevron-right'></i>
                  <Link to='/leadership'>Leadership</Link>
                </li>
                <li>
                  <i className='bi bi-chevron-right'></i>
                  <Link to='/achievements-and-media'>Achievements</Link>
                </li>

                <li>
                  <i className='bi bi-chevron-right'></i>
                  <Link to='/expertise'>Our Expertise</Link>
                </li>
                <li>
                  <i className='bi bi-chevron-right'></i>
                  <Link to='/projects'>Projects</Link>
                </li>
              </ul>
            </div>

            <div className='col-lg-2 col-6 footer-links'>
              <h4>Our Services</h4>
              <ul>
                <li>
                  <i className='bi bi-chevron-right'></i>
                  <Link to='/expertise'>Water Management</Link>
                </li>
                <li>
                  <i className='bi bi-chevron-right'></i>
                  <Link to='/expertise'>Waste Water Management</Link>
                </li>
              </ul>
            </div>

            <div
              className='
              col-lg-3 col-md-12
              footer-contact
              text-center text-md-start
            '
            >
              <h4>Contact Us</h4>
              <p>
                DLF Galleria,
                <br />
                Action Area I, Newtown Kolkata,
                <br />
                West Bengal - 700156
              </p>
              <p>
                <strong>Phone:</strong>
                +91 33-4069-4101
                <br />
                <strong>Email:</strong>
                info@rean.co.in
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='container'>
        <div className='copyright'>
          &copy; Copyright
          <strong>
            <span>Rean Watertech Pvt. Ltd.</span>
          </strong>
          . All Rights Reserved
        </div>
      </div>
    </footer>
  )
}

export default Footer
